import { ref } from 'vue';

export const eventBus = {
  events: ref({}),

  emit(event) {
    if (this.events.value[event]) {
      this.events.value[event].forEach((callback) => callback());
    }
  },

  on(event, callback) {
    if (!this.events.value[event]) {
      this.events.value[event] = [];
    }
    this.events.value[event].push(callback);
  },
  off(event, callback) {
    if (this.events.value[event]) {
      this.events.value[event] = this.events.value[event].filter(
        (cb) => cb !== callback,
      );
    }
  },
};
